import {SignupParams} from "features/authentication/types.services";

export const PurchaseServiceEndpoints = {
    addPurchase: () => `/signup_service/purchase`,
    addPurchaseEidentStart: () => `/signup_service/purchase/eident/start`,
    addPurchaseEidentStatus: () => `/signup_service/purchase/eident/status`,
    updatePriority: () => `/signup_service/purchase/update_priority`,
    deletePurchase: ({stageId, objectId} : SignupParams) => `/signup_service/purchase/${stageId}/${objectId || ''}`,
    addPurchaseMailProxy: () => '/purchase',
};

export const PooledPurchaseKey = 'pooled-purchase';
